import React from "react";

function About() {
  return (

    <div className="about section">
      <div className ="aboutInner">
      <h2 className="aboutHeader">About</h2>
      <p className="aboutText">
        GistGate News App seeks to bring together all your favourites news
        sources in the world for easier consumption by all who love the news. We
        seek to make quality information more easily accessible. GistGate News
        App is a subsidiary of GistGate Media International. A Registered Media
        startup whose main objective is to make meaningful and useful
        information more easily accessible across the globe and especially in
        the developing world. We are open to suggestions on how to improve and
        we are also open to investment and grants because there is a lot more in
        our minds and books that we will love to make this app become.
      </p>
      </div>
    </div>
  );
}

export default About;
